/*
 * @Author: wangzongyu
 * @Date: 2020-07-30 19:18:22
 * @LastEditors: pengyong
 * @LastEditTime: 2020-11-24 14:12:29
 * @Description:
 * @FilePath: /web-ac-client/src/api/env.js
 */

const TEST_SERVER = 'test-client.aircourses.com'; // 测试服
const DEV_SERVER = 'dev-client.aircourses.com'; // 开发服
const PRE_SERVER = '47.111.78.238'; // 预发布
const PRE_SERVER_HTTPS = 'pre-client.aircourses.com'; // 预发布
const PROD_SERVER = 'client.aircourses.com'; // 正式服

const ENV = {
    local: {
        env: 'local',
        baseUrl: 'http://localhost:3000',
        wxBaseUrl: 'http://dev-wx.aircourses.com',
        apiBaseUrl: 'http://dev-api.aircourses.com',
        bpBaseUrl: 'http://dev-bp.aircourses.com'
    },
    dev: {
        env: 'dev',
        baseUrl: 'http://dev-client.aircourses.com',
        wxBaseUrl: 'http://dev-wx.aircourses.com',
        apiBaseUrl: 'http://dev-api.aircourses.com',
        bpBaseUrl: 'http://dev-bp.aircourses.com'
    },
    test: {
        env: 'test',
        baseUrl: 'http://test-client.aircourses.com',
        wxBaseUrl: 'http://test-wx.aircourses.com',
        apiBaseUrl: 'http://test-api.aircourses.com',
        bpBaseUrl: 'http://test-bp.aircourses.com'
    },
    pre: {
        env: 'pre',
        baseUrl: 'https://pre-client.aircourses.com',
        wxBaseUrl: 'https://pre-wx.aircourses.com',
        apiBaseUrl: 'https://pre-api.aircourses.com',
        bpBaseUrl: 'https://pre-bp.aircourses.com'
    },
    prod: {
        env: 'prod',
        baseUrl: 'https://client.aircourses.com',
        wxBaseUrl: 'https://wx.aircourses.com',
        apiBaseUrl: 'https://api.aircourses.com',
        bpBaseUrl: 'https://bp.aircourses.com'
    },
};

let BASE_CONFIG;

switch (window.location.hostname) {
    case TEST_SERVER:
        BASE_CONFIG = ENV.test;
        break;
    case DEV_SERVER:
        BASE_CONFIG = ENV.dev;
        break;
    case PRE_SERVER:
    case PRE_SERVER_HTTPS:
        BASE_CONFIG = ENV.pre;
        break;
    case PROD_SERVER:
        BASE_CONFIG = ENV.prod;
        break;
    default: BASE_CONFIG = ENV.prod;
        break;
}

export default BASE_CONFIG;


// WEBPACK FOOTER //
// ./src/api/env.js